import { HTTP_PANTRY_FETCHING, HTTP_PANTRY_SUCCESS, HTTP_PANTRY_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_PANTRY_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_PANTRY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_PANTRY_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
